import { WorkerHourlyReportController } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * Component for HourlyReport usecase
 * @example
 * ```html
 * <salaxy-hourly-report></salaxy-hourly-report>
 * ```
 */
export class HourlyReport extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
     public bindings = WorkerHourlyReportController.bindings;

    /** Uses the WorkerHourlyReportController */
    public controller = WorkerHourlyReportController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/communications/messages/message-types/HourlyReport.html";

}
